import React from 'react';
import clsx from 'clsx';
import { Text, TextMarkup } from '../text';
import { has, is } from '../../services/classify';
import { Icon, IconSize } from '../icon';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Link Component
 * @param children {React.ReactNode} Content children for Link
 * @param href {string} Link to open
 * @param to {string} use for rooter
 * @param tertiary {boolean} Tertiary variant
 * @param title {string} Title attribute
 * @param onClick {Function} onClick Event
 * @param typo {TypographyAlign} Typos align link
 * @param accessibilityLabel {string} Accessibility label
 * @param iconName {IconName} Adding Icon Link
 * @param testId {string} Test Id for Test Integration
 * @param others
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param fixed {boolean} Static link with no animation
 * @param className {string} Additionnal CSS Classes
 * @param href {string} Href link
 * @param removeLinkClass {boolean}
 * @param routerLink Custom Router Link as props
 * @param blank Link Target Blank
 * @param role Link Role
 * -------------------------- NATIVE PROPERTIES -------------------------------
 * @param inline {boolean} If link is inside paragraphe
 * @param level {TextLevels} if inline, size to match with Text
 */
const Link = ({ children, className, removeLinkClass, fixed, to, href, tertiary, title, onClick, typo, testId, accessibilityLabel, routerLink, iconName, inverted, role, blank, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = clsx(!removeLinkClass && 'link', fixed && is('static'), tertiary && has('text-tertiary'), iconName && has('icon'), typo, inverted && is('inverted'), className);
    const renderLink = (RouterLink, props) => {
        return (React.createElement(RouterLink, { "data-testid": testId, "aria-label": accessibilityLabel, onClick: onClick && onClick, className: routerLink ? hashClass(styled, clsx(classes)) : clsx(classes), ...props, role: role, title: title, ...(blank && {
                target: '_blank',
            }), ...others },
            children || title,
            iconName && React.createElement(Icon, { name: iconName, size: IconSize.SMALL })));
    };
    let returnComponent;
    if (routerLink) {
        returnComponent = renderLink(routerLink, { href: href, to: to });
    }
    else {
        returnComponent = renderLink(Text, { href: href, markup: TextMarkup.A });
    }
    if (typo) {
        return React.createElement("div", { className: hashClass(styled, clsx(typo)) }, returnComponent);
    }
    else {
        return returnComponent;
    }
};
export default Link;
//# sourceMappingURL=Link.js.map